import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "relative" }

import { onMounted } from "vue";

import { Toast } from "@/components/common";
import ControllersModule from "@/modules/controllers";

import { isMain } from "./utils/helpers";

// const isDarkMode = computed(() => {
//   log.info(ControllersModule.isDarkMode, "isDarkMode");
//   return ControllersModule.isDarkMode;
// });


export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

// import log from "loglevel";
onMounted(() => {
  if (isMain)
    ControllersModule.init({
      origin: window.location.origin,
    });
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_view),
    _createVNode(_unref(Toast))
  ]))
}
}

})